import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { Link } from "react-router-dom";
import { db } from "../../firebase/firebaseConfig";
import { useTranslation } from "react-i18next";
import { FaStar } from "react-icons/fa6";
import Breadcrumb from "../../components/ui/Breadcrumb";
import routePaths from "../../routes/routePaths";
import SeoMeta from "../../components/ui/SeoMeta";

const ProgramsPage = () => {
  const [programs, setPrograms] = useState([]);
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  useEffect(() => {
    const fetchPrograms = async () => {
      const q = query(collection(db, "programs"), orderBy("displayOrder"));
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setPrograms(data);
    };
    fetchPrograms();
  }, []);

  return (
    <div className="py-6 px-4">
      <SeoMeta page="program-page" initialMeta={{title: `${t("programs.breadcrumb")}`, description: "" }} />
      <Breadcrumb items={[
        { label: t("programs.breadcrumb") }
      ]} />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {programs.map((program) => {
          const level = program.level?.[lang] || program.level?.vi || program.slug;
          const name = program.name?.[lang] || program.name?.vi || level;
          let description =
            program.description?.[lang] ||
            program.description?.vi ||
            "";
          const MAX_LEN = 200;
          if (description.length > MAX_LEN) {
            description = description.slice(0, MAX_LEN) + "…";
          }
          return (
            <Link
              to={`${routePaths.programs}/${program.slug}`}
              key={program.id}
              className="
                group bg-card rounded border border-border 
                shadow-sm hover:shadow-md hover:border-primary 
                transition p-7 min-h-[240px] flex flex-col
              "
            >
              <div className="flex items-center gap-2 mb-3">
                <FaStar className="text-secondary text-xl drop-shadow" />
                <span className="text-primary font-bold text-base">{level}</span>
              </div>
              <h2 className="text-xl font-extrabold text-menu group-hover:text-primary transition mb-2">
                {name}
              </h2>
              <p className="text-text2 text-sm flex-1">{description}</p>
              <div className="mt-5 text-right">
                <span className="text-textLink font-bold hover:text-secondary transition text-base">
                  {t("programs.viewDetails")}
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default ProgramsPage;
